enum RoundType {
    NORMAL = "normal",
    FREE_SPIN = "free_spin",
    RE_SPIN = "re_spin",
    JACKPOT = "jackpot",
    BONUS = "bonus",
    FREE_GAME = "free_game",
    DEMO = "demo",
    CASCADE = "cascade"
}

export default RoundType
